import BoostModalFooter from './BoostModalFooter';

export default BoostModalFooter;
